import axios from "axios";

// Runtime-safe backend URL resolution.
//
// Problem we solve: CRA bakes REACT_APP_BACKEND_URL at BUILD time. When the
// app is later published under a custom domain (e.g. meradashboards.com),
// the bundle still points at the old preview URL → browsers block the
// cross-origin POST (cookies/CORS) and login fails silently.
//
// Strategy:
//   1. In a real browser on a real domain (anything but localhost/127.0.0.1),
//      ALWAYS use window.location.origin. Emergent native deployment serves
//      frontend and backend under the same ingress, so same-origin is correct.
//   2. On localhost, prefer the build-time env (dev proxy / local API).
//   3. SSR fallback: trust the env (window is undefined).
function resolveBackendUrl() {
  const buildEnv = process.env.REACT_APP_BACKEND_URL || "";
  if (typeof window === "undefined") return buildEnv;
  const { origin, hostname } = window.location;
  const isLocal = hostname === "localhost" || hostname === "127.0.0.1" || hostname === "0.0.0.0";
  if (isLocal) return buildEnv || origin;
  // Production / preview / custom domain — same-origin wins.
  return origin;
}

const BACKEND_URL = resolveBackendUrl();
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// Attach bearer from localStorage as fallback (for cross-origin cookie issues)
api.interceptors.request.use((config) => {
  const t = localStorage.getItem("mptg_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
